import { render, staticRenderFns } from "./ComparativeAnalysisEmployee2.vue?vue&type=template&id=2887af05&scoped=true&"
import script from "./ComparativeAnalysisEmployee2.vue?vue&type=script&lang=js&"
export * from "./ComparativeAnalysisEmployee2.vue?vue&type=script&lang=js&"
import style0 from "./ComparativeAnalysisEmployee2.vue?vue&type=style&index=0&id=2887af05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887af05",
  null
  
)

export default component.exports